function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.064 9.421A13.94 13.94 0 0 1 30 18c0 7.732-6.268 14-14 14S2 25.732 2 18C2 10.604 7.735 4.548 15 4.035V2h-2.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H17v2.035a13.925 13.925 0 0 1 7.187 2.607l1.288-1.288a.5.5 0 0 1 .707 0l2.121 2.12a.5.5 0 0 1 0 .708l-1.239 1.239zM13.171 19H8a1 1 0 1 1 0-2h5.17a3.001 3.001 0 1 1 0 2zM16 30c6.627 0 12-5.373 12-12S22.627 6 16 6 4 11.373 4 18s5.373 12 12 12zm0-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3-8.418V8.457c4.057 1.274 7 5.064 7 9.542 0 5.523-4.477 10-10 10-4.1 0-7.625-2.468-9.168-6H9.07A8 8 0 1 0 19 10.582zM15 8h2v2h-2V8z"
});

var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "5b26ceb9367cbbfabb4ea1b61df50a31.svg";
export { SvgStopwatch as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/stopwatch.svg
// module id = null
// module chunks = 